export default "__VITE_ASSET__Di5FcVFB__"